<div class="upload-file-container">
  @if(!showMode){
  <div class="d-flex align-items-center">
    <img src="../../../../assets/images/icons/upload-file.svg" alt="" />

    <div
      class="content-wrapper d-flex flex-column mx-3 w-100"
      (click)="triggerInput()">
      <input
        #attachment
        [id]="inputFileId"
        type="file"
        [accept]="acceptFiles"
        [multiple]="!oneFile"
        (change)="beforeUpload($event)"
        [disabled]="showMode" />
      <span class="click-me">{{ "Click-To-Browse" | translate }}</span>
      <span class="file-extention"
        >{{ isImage ? ("File-Images" | translate) : ("File-Types" | translate
        )}}</span
      >
    </div>
  </div>
  }
  <div class="uploaded-file-container">
    @if(fileList.length > 0 ) {
    <div class="upload-file-wrapper">
      @for (file of fileList; track file; let i = $index) {
      <div class="d-flex justify-content-between align-items-center w-100 mt-2">
        <div class="d-flex align-items-center">
          <i class="bi bi-paperclip attchment-icon"></i>
          <a
            class="font-14 dark font-medium-bold cursor-pointer attachment"
            (click)="download(i)">
            <p>{{ (file.name || file).split("hema/").pop() }}</p>
          </a>
        </div>
        @if(!showMode){
        <button
          type="button"
          class="icon-wrapper btn-reset"
          [attr.aria-label]="'Aria.Delete' | translate"
          (click)="remove(i)">
          <i class="bi bi-x"></i>
        </button>
        }
      </div>
      }
    </div>
    }@else if(showMode && fileList.length == 0 ){
    <p>{{ "Common-Msg.No-Attachments-Found" | translate }}</p>
    }
  </div>
</div>
